function UserModifiedIcon() {
    return (
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#user_clip)">
                <path
                    d="M7.33334 5.04166L8.25 5.95833L10.0833 4.125"
                    stroke="#23A35A"
                    strokeWidth="0.916667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.33333 9.625V8.70834C7.33333 8.22211 7.14018 7.75579 6.79636 7.41197C6.45255 7.06816 5.98623 6.875 5.5 6.875H2.75C2.26377 6.875 1.79745 7.06816 1.45364 7.41197C1.10982 7.75579 0.916666 8.22211 0.916666 8.70834V9.625"
                    stroke="#23A35A"
                    strokeWidth="0.916667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.125 5.04167C5.13752 5.04167 5.95833 4.22085 5.95833 3.20833C5.95833 2.19581 5.13752 1.375 4.125 1.375C3.11248 1.375 2.29167 2.19581 2.29167 3.20833C2.29167 4.22085 3.11248 5.04167 4.125 5.04167Z"
                    stroke="#23A35A"
                    strokeWidth="0.916667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="user_clip">
                    <rect width="11" height="11" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default UserModifiedIcon;
